import { css as e, styled as o } from "styled-components";
import { Icon as l } from "../Icon/index.js";
import { Image as a } from "../Image/index.js";
import { skeletonFadeAnimation as d } from "../../styles/animation.js";
import { MediaQuery as h } from "../../styles/variables.js";
import { Colors as m } from "../../styles/colors/index.js";
import { Theme as r } from "../../styles/themes/index.js";
var i = /* @__PURE__ */ ((t) => (t.EXTRA_SMALL = "extraSmall", t.SMALL = "small", t.MEDIUM = "medium", t.LARGE = "large", t.HUGE = "huge", t.STORE = "store", t.PROFILE = "profile", t))(i || {});
const n = e`
  width: 18px;
  height: 18px;
`, p = e`
  width: 24px;
  height: 24px;
`, g = e`
  width: 36px;
  height: 36px;
`, c = e`
  width: 48px;
  height: 48px;
`, x = e`
  width: 60px;
  height: 60px;
`, f = e`
  width: 56px;
  height: 56px;

  @media ${h.SCREEN_MD_UP} {
    width: 64px;
    height: 64px;
  }
`, b = e`
  width: 64px;
  height: 64px;
`, s = {
  extraSmall: n,
  small: p,
  medium: g,
  large: c,
  huge: x,
  store: f,
  profile: b
}, u = Object.values(i).map(
  (t) => e`
    &[data-size='${t}'] {
      ${s[t]}
    }
  `
), L = o(a)`
  display: block;
  border: 1px solid rgb(${r.colors.Golf});
  border-radius: 50%;
  overflow: hidden;
  word-break: break-all;
  object-fit: cover;
  background-color: rgba(${m.Ice}, 0.5);
  flex-shrink: 0;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    aspect-ratio: 1/1;
  }
`, M = o(l)`
  position: absolute;
  right: 0;
  bottom: 0;
  transform: translateX(50%);
  border: 1px solid rgb(${r.colors.Golf});
  background-color: rgb(${r.colors.Golf});
  border-radius: 50%;
  height: 0.5em;
  width: 0.5em;
  font-size: 18px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`, C = o.div`
  position: relative;
  display: inline-block;

  &[data-hasbadge='true'] {
    margin-right: 0.25em;
  }

  ${u}
`, G = o.div`
  border-radius: 50%;
  flex-shrink: 0;

  ${({ size: t }) => s[
  t || "medium"
  /* MEDIUM */
]}
  ${d}
`;
export {
  M as AvatarBadge,
  C as AvatarContainer,
  L as AvatarImage,
  i as AvatarSize,
  G as AvatarSkeletonContainer
};
